import { defineComponent, h } from 'vue'
import { mapState } from 'vuex'

export default (component: any) => defineComponent({
  computed: {
    ...mapState({
      presentation: (state: any) => state.presentation,
    }),
  },
  render() {
    return h(component, {
      ...this.$attrs,
      presentationName: this.presentation.name,
      accessCode: this.presentation.accessCode,
    })
  },
})
